/* tslint:disable */

declare var Object: any;
export interface Sfspt1721iInterface {
  "id"?: number;
}

export class Sfspt1721i implements Sfspt1721iInterface {
  "id": number;
  constructor(data?: Sfspt1721iInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Sfspt1721i`.
   */
  public static getModelName() {
    return "Sfspt1721i";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Sfspt1721i for dynamic purposes.
  **/
  public static factory(data: Sfspt1721iInterface): Sfspt1721i{
    return new Sfspt1721i(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Sfspt1721i',
      plural: 'Sfspt1721is',
      path: 'Sfspt1721is',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/Sfspt1721i.ts